"use client";

import { useEffect, useState } from "react";
import { Moon, Sun } from "lucide-react";

type Theme = "dark" | "light";

export default function ThemeToggle({ className = "" }: { className?: string }) {
  const [theme, setTheme] = useState<Theme>("light");
  const [mounted, setMounted] = useState(false);

  useEffect(() => {
    const t = (document.documentElement.getAttribute("data-theme") as Theme) || "light";
    const id = setTimeout(() => { setTheme(t); setMounted(true); }, 0);
    return () => clearTimeout(id);
  }, []);

  const toggle = () => {
    const next: Theme = theme === "dark" ? "light" : "dark";
    document.documentElement.setAttribute("data-theme", next);
    try { localStorage.setItem("theme", next); } catch {}
    setTheme(next);
  };

  return (
    <button
      type="button"
      onClick={toggle}
      aria-label={`Switch to ${theme === "dark" ? "light" : "dark"} theme`}
      className={`inline-flex h-8 w-8 cursor-pointer items-center justify-center rounded-md border border-ink/[0.18] text-ink-2 transition-all duration-200 ease-out hover:border-accent hover:text-ink hover:bg-ink/[0.04] focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-accent/60 ${className}`}
    >
      {mounted && theme === "dark" ? <Sun size={14} /> : <Moon size={14} />}
    </button>
  );
}
